import { render, staticRenderFns } from "./TanyaGuru.vue?vue&type=template&id=5e94cfb2&scoped=true"
import script from "./TanyaGuru.vue?vue&type=script&lang=js"
export * from "./TanyaGuru.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e94cfb2",
  null
  
)

export default component.exports